'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UITag = require('UIComponents/tag/UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AbsoluteFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'CurrentPlanTag__AbsoluteFlex'
})(['position:absolute;']);

var Tag = (0, _styledComponents2.default)(_UITag2.default).withConfig({
  displayName: 'CurrentPlanTag__Tag'
})(['border-top:0;border-right:0;']);

var CurrentPlanTag = function CurrentPlanTag() {
  return _react2.default.createElement(
    AbsoluteFlex,
    { justify: 'end' },
    _react2.default.createElement(
      Tag,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.highlightedMerchCards.currentPlan' })
    )
  );
};

exports.default = CurrentPlanTag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CurrentPlanTag.js
// module id = 596
// module chunks = 3 4